import _isUndefined from 'lodash/isUndefined';
import { useMediaQuery } from '@mui/material';

const _hasValue = (value: any): boolean => !_isUndefined(value);

const _handleDefaultValue = (props: {
  xs?: any;
  sm?: any;
  md?: any;
  lg?: any;
  xl?: any;
}) => {
  if (_hasValue(props.xs)) return props.xs;
  if (_hasValue(props.sm)) return props.sm;
  if (_hasValue(props.md)) return props.md;
  if (_hasValue(props.lg)) return props.lg;
  if (_hasValue(props.xl)) return props.xl;
  return undefined;
};

export default function useResponsive() {
  const isXS = useMediaQuery(
    (theme: any) => `(min-width:${theme.breakpoints.values.xs}px)`
  );
  const isSM = useMediaQuery(
    (theme: any) => `(min-width:${theme.breakpoints.values.sm}px)`
  );
  const isMD = useMediaQuery(
    (theme: any) => `(min-width:${theme.breakpoints.values.md}px)`
  );
  const isLG = useMediaQuery(
    (theme: any) => `(min-width:${theme.breakpoints.values.lg}px)`
  );
  const isXL = useMediaQuery(
    (theme: any) => `(min-width:${theme.breakpoints.values.xl}px)`
  );

  function matches(props: {
    xs?: any;
    sm?: any;
    md?: any;
    lg?: any;
    xl?: any;
  }) {
    let result = _handleDefaultValue(props);
    if (_hasValue(props.xs) && isXS) result = props.xs;
    if (_hasValue(props.sm) && isSM) result = props.sm;
    if (_hasValue(props.md) && isMD) result = props.md;
    if (_hasValue(props.lg) && isLG) result = props.lg;
    if (_hasValue(props.xl) && isXL) result = props.xl;
    return result;
  }

  return { matches };
}
